import { Head, Link } from "@inertiajs/react";
import { Card, Flex, Heading, Link as RadixLink, Strong, Text } from "@radix-ui/themes";

import { AppLayout } from "@/components/app-layout";
import type { SharedProps } from "@/lib/types";

type ProjectShowProps = SharedProps & {
  project: {
    id: number;
    internal_id: string;
    name: string;
    status: string;
    project_owner_email: string;
    project_manager_email: string;
    frontend_lead_email: string;
    backend_lead_email: string;
    harvest_project_id: string | null;
    quickbooks_customer_id: string | null;
    asana_workspace_id: string | null;
    google_drive_folder_id: string | null;
    vcs_repository_links: string[];
  };
};

export default function ProjectsShow({ auth, project }: ProjectShowProps) {
  return (
    <>
      <Head title={project.name} />
      <AppLayout
        user={auth.user}
        activeModule="weekly_planner"
        onModuleChange={() => {}}
        pageTitle={project.name}
        pageActions={
          <Flex align="center" gap="4">
            {auth.user?.roles.includes("administrator") && (
              <RadixLink asChild size="2">
                <Link href={`/projects/${project.id}/edit`}>Edit Project</Link>
              </RadixLink>
            )}
            <RadixLink asChild size="2">
              <Link href="/projects">Back to projects</Link>
            </RadixLink>
          </Flex>
        }
      >
        <Card className="space-y-4 p-4">
          <div className="grid grid-cols-2 gap-2 text-sm">
            <Text size="2">
              <Strong>Internal ID:</Strong> {project.internal_id}
            </Text>
            <Text size="2">
              <Strong>Status:</Strong> {project.status}
            </Text>
            <Text size="2">
              <Strong>PO:</Strong> {project.project_owner_email}
            </Text>
            <Text size="2">
              <Strong>PM:</Strong> {project.project_manager_email}
            </Text>
            <Text size="2">
              <Strong>FE:</Strong> {project.frontend_lead_email}
            </Text>
            <Text size="2">
              <Strong>BE:</Strong> {project.backend_lead_email}
            </Text>
            <Text size="2">
              <Strong>Harvest Project ID:</Strong> {project.harvest_project_id || "-"}
            </Text>
            <Text size="2">
              <Strong>QuickBooks Customer ID:</Strong> {project.quickbooks_customer_id || "-"}
            </Text>
            <Text size="2">
              <Strong>Asana Workspace ID:</Strong> {project.asana_workspace_id || "-"}
            </Text>
            <Text size="2">
              <Strong>Google Drive Folder ID:</Strong> {project.google_drive_folder_id || "-"}
            </Text>
          </div>

          <div>
            <Heading mb="2" size="3">
              Repositories
            </Heading>
            <ul className="list-inside list-disc text-sm">
              {project.vcs_repository_links.map((url) => (
                <li key={url}>
                  <RadixLink href={url} target="_blank" rel="noreferrer">
                    {url}
                  </RadixLink>
                </li>
              ))}
            </ul>
          </div>
        </Card>
      </AppLayout>
    </>
  );
}
